<!-- Time -->
<app-nokkeltall-hour
  *ngIf="_chartTypes.Time.active && valgtTimeAnlegg && valgtAvtale"
  [valgtTimeAnlegg]="valgtTimeAnlegg"
  [selectedDate]="selectedDateHour"
  [isStromstotteToggled]="isStromstotteToggled"
></app-nokkeltall-hour>
<!-- Dag -->
<app-nokkeltall-day
  *ngIf="_chartTypes.Dag.active && valgtAnlegg && valgtAvtale"
  [valgtAnlegg]="valgtAnlegg"
  [selectedDate]="selectedDateDay"
  [valgtAvtale]="valgtAvtale"
  [_foretakMap]="_foretakMap"
  [isStromstotteToggled]="isStromstotteToggled"
></app-nokkeltall-day>
<!-- Måned -->
<app-nokkeltall-month
  *ngIf="_chartTypes.Maaned.active && valgtAnleggMaaned && valgtAvtale"
  [valgtMaanedAnlegg]="valgtAnleggMaaned"
></app-nokkeltall-month>
<!-- År -->
<app-nokkeltall-year
  *ngIf="_chartTypes.Aar.active && valgtAnleggAar && valgtAvtale"
  [valgtAarAnlegg]="valgtAnleggAar"
  [isBrowser]="isBrowser"
></app-nokkeltall-year>
